import { Controller } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";

import { FormInputProps } from "./FormInputProps";
import { displayFlex } from "../styles/mui/styles/display";
import { InputTextLabel } from "./styles/styles";
import { getValue, handleInputEvent } from "../utils";
import fontWeight from "../styles/mui/fontWeight";
import colors from "../styles/colors/colors";

export const FormInputTextStandard = ({
  control,
  dataTestId,
  disabled,
  handleChange,
  helper,
  label,
  maxRow,
  multiline,
  name,
  onKeyPress,
  placeholder,
  searchInputRef,
  textLength,
  inputType,
  mandatorySymbol,
  InputStyle,
  inputVariant,
  inputRows,
  readOnly,
}: FormInputProps) => {
  let props = {};
  if (inputRows) {
    props = {
      rows: inputRows,
    };
  } else {
    props = {
      maxRows: maxRow || 2,
    };
  }
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={""}
      rules={helper}
      render={({
        field: { onChange, value, ref, onBlur },
        fieldState: { error },
      }) => (
        <TextField
          required={
            helper &&
            helper.required &&
            helper.required.value
          }
          error={error !== undefined}
          helperText={error ? error.message : ""}
          {...props}
          onChange={(e) => {
            onChange(e);
            handleChange && handleChange(e);
          }}
          onBlur={onBlur}
          value={value || ""} // handle null/undefined
          onKeyUp={(e) => {
            onKeyPress && onKeyPress(e);
          }}
          onInput={(e) => {
            handleInputEvent(e, inputType);
          }}
          fullWidth
          sx={InputStyle ? InputStyle : InputTextLabel}
          label={
            <Box sx={displayFlex}>
              <Typography
                variant="h4"
                fontWeight={fontWeight[4]}
                color={colors.fonts[2]}
              >
                {label}
              </Typography>
              {!getValue(helper, "required.value", "") && mandatorySymbol && (
                <Typography
                  variant="h3"
                  fontWeight={fontWeight[3]}
                  color={colors.red[100]}
                  pl={"0.4rem"}
                >
                  *
                </Typography>
              )}
            </Box>
          }
          placeholder={
            name.includes("streetName1") || name.includes("streetName2")
              ? "Add here..."
              : placeholder
          }
          disabled={disabled}
          multiline={multiline || false}
          inputProps={{
            maxLength: textLength ? textLength : 50,
            ref: searchInputRef ? searchInputRef : null,
            autoComplete: "none",
          }} // text
          InputProps={{
            readOnly: readOnly
          }}
          variant={inputVariant ? "outlined" : "standard"}
          inputRef={ref}
          InputLabelProps={{ shrink: true }}
          data-testid={dataTestId}
        />
      )}
    />
  );
};
